<eqa-scroll-controls *ngIf="showScrollbars"></eqa-scroll-controls>
<div class="scroll-content">
	<ng-content></ng-content>
</div>
